import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	weeklyProdDeployments: {
		id: 'software-deployment-frequency-report.batch-size-chart.weekly-prod-deployments',
		defaultMessage:
			'{weeklyProdDeployments, plural, =0 {No weekly production deployments} one {1 weekly production deployment} other {# weekly production deployments}}',
		description: 'Title of a chart describing number of weekly production deployments.',
	},
	issuesPerDeployment: {
		id: 'software-deployment-frequency-report.batch-size-chart.issues-per-deployment',
		defaultMessage:
			'{periodProdIssuesPerDeployment} {periodProdIssuesPerDeployment, plural, one {median issue per deployment} other {median issues per deployment}}',
		description:
			'statistic describing number of median Jira issues per deployment in the selected period of time',
	},
	issuesPerDeploymentIssueTermRefresh: {
		id: 'software-deployment-frequency-report.batch-size-chart.issues-per-deployment-issue-term-refresh',
		defaultMessage:
			'{periodProdIssuesPerDeployment} {periodProdIssuesPerDeployment, plural, one {median work item} other {median work items}} per deployment',
		description:
			'statistic describing number of median Jira issues per deployment in the selected period of time',
	},
	weekTitle: {
		id: 'software-deployment-frequency-report.batch-size-chart.week-title',
		defaultMessage: 'week of {date}',
		description: 'Title describing the week of the report. e.g. Week of March 22',
	},
	moreDataRequired: {
		id: 'software-deployment-frequency-report.batch-size-chart.more-data-required',
		defaultMessage: 'more data required',
		description: 'Display when data is empty indicating user has no data to show the graph',
	},
	deployment: {
		id: 'software-deployment-frequency-report.batch-size-chart.deployment',
		defaultMessage: 'Deployment',
		description: 'Label in a legend. Deployment is a tech term that is often not translated.',
	},
	twelveWeekMedian: {
		id: 'software-deployment-frequency-report.batch-size-chart.twelve-week-median',
		defaultMessage: '12-week median',
		description:
			'Label in a legend. Represents the median deployment frequency over the past 12 weeks.',
	},
	weekBreakDownTitle: {
		id: 'software-deployment-frequency-report.batch-size-chart.week-break-down-title',
		defaultMessage: 'Week breakdown',
		description:
			'Title of the week break down area of the selected week production deployment detail',
	},
	weekBreakDownTitleTooltip: {
		id: 'software-deployment-frequency-report.batch-size-chart.week-break-down-title-tooltip',
		defaultMessage:
			'Identify the risk of your deployments by analyzing their batch sizes. Deployments with many changes tend to be riskier.',
		description:
			'Tooltip that is displayed when mouse is hovered over the week break down title question mark. Batch sizes refers how big production deployment is. The bigger deployments contain more changes which makes the deployment more risky.',
	},
	errorFlagTitle: {
		id: 'software-deployment-frequency-report.batch-size-chart.error-flag-title',
		defaultMessage: 'Something went wrong',
		description:
			'Title of the error flag that is displayed when there is an error in the batch size chart',
	},
	errorFlagDescription: {
		id: 'software-deployment-frequency-report.batch-size-chart.error-flag-description',
		defaultMessage: 'Some deployments may be missing.',
		description:
			'Description of the error flag that is displayed when there is an error in the batch size chart',
	},
});
